/* ImportScreenComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./ImportScreenRenderer");

class ImportScreenComponent extends EventEmitter {
    constructor(CommandSetEntity, logger, io, uiUtils, orgId) {
        super();
        this._logger = logger;
        this._CommandSetEntity = CommandSetEntity;
        this._io = io;
        this._orgId = orgId;
        this._uiUtils = uiUtils;
        this._context = {};
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._CommandSetEntity = undefined;
                this._io = undefined;
                this._orgId = undefined;
                this._uiUtils = undefined;
                this._context = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ImportScreenComponent.shutdown() error.");
            }
        );
    }

    sendImportData(data) {
        this._context.resolve({
            importData: data,
        });
    }

    sendImportError(err) {
        this._context.reject(err);
    }

    parseData(file, type) {
        return new Promise((resolve, reject) => {
            const isValidJson = (str) => {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            };

            const onloadHandler = () => (e) => {
                const content = e.target.result;
                if (_.isEmpty(content) || !isValidJson(content)) {
                    reject({
                        errorCode: "InvalidFileFormat",
                        errorMsg: "Unsupported file format",
                    });
                }

                const data = JSON.parse(content);
                if (_.get(data, "metadata.formatType") !== "command_set") {
                    reject({
                        errorCode: "UnknownFileFormatType",
                        errorMsg: "Unknown file format type",
                    });
                }
                if (!_.get(data, "data.commandSets") || !_.get(data, "data.redactionRegexes")) {
                    reject({
                        errorCode: "Invalidfileformat",
                        errorMsg: "Unsupported file format",
                    });
                } else if (_.get(data, "metadata.version") !== "1.0.0") {
                    reject({
                        errorCode: "InvalidFileVersion",
                        errorMsg: "Unsupported file version",
                    });
                } else {
                    resolve(data);
                }
            };

            const onErrorHandler = (error) => {
                reject({
                    errorCode: "FileReadError",
                    errorMsg: "File reading error",
                    errorStack: error,
                });
            };

            if (type === "json") {
                let fileReader = new FileReader();
                fileReader.onload = onloadHandler();
                fileReader.onerror = onErrorHandler;
                fileReader.readAsText(file);
            } else {
                reject({
                    errorCode: "UnknownImportFileType",
                    errorMsg: `Unsupported file type used for import: ${type}`,
                });
            }
        })
            .then((data) => this.sendImportData(data))
            .catch((error) => {
                this._logger.warn({error}, "ImportScreenComponent data parse error.");
                this.sendImportError(error);
            });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ImportScreenComponent;
